/**
 * Citation + clipboard helpers for BrandProfile documents.
 *
 * Kept in a tiny module (rather than inline in BrandProfile.jsx) so the
 * "Cite this PDF" button can be reused in other public pages later (e.g.
 * sector reports) without dragging the whole profile page along.
 */

/** Build an APA-style citation for a corporate/organizational document. */
export function buildCitation({ brandName, title, url, fetchedAt }) {
  const yearFromTitle = (title || "").match(/(19|20|21)\d{2}/);
  const yearFromDate = fetchedAt ? String(fetchedAt).slice(0, 4) : "n.d.";
  const year = yearFromTitle ? yearFromTitle[0] : yearFromDate;
  const retrieved = fetchedAt ? String(fetchedAt).slice(0, 10) : "";
  const cleanTitle = (title || url || "").replace(/\s+/g, " ").trim();
  const retrievedPart = retrieved ? ` Retrieved ${retrieved}, from ${url}` : ` ${url}`;
  return `${brandName}. (${year}). ${cleanTitle}.${retrievedPart}`;
}

export async function copyToClipboard(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
